import { i18n } from "./i18n";
import { setLanguage, storeLang } from "./store";

function useLanguage() {
  const { language } = storeLang.useState();
  const dispatch = storeLang.useDispatch();
  const isPersian = language === "fa";
  const isRtl = i18n.dir() === "rtl";
  function changeLanguage() {
    dispatch(setLanguage(isPersian ? "en" : "fa"));

    i18n.changeLanguage(language);
  }
  return { language, isPersian, changeLanguage, isRtl };
}

export { useLanguage };
